module.exports = __webpack_public_path__ + "static/media/FazzNeue-MediumItalic.20b105ce.ttf";